/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_appsync_graphqlEndpoint": "https://42feyce6azacti5pxxjcajvwyq.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7rse2uo7tjfj5lxkholmqkgkri",
    "aws_content_delivery_bucket": "winstonstone-20241210224950-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "ap-south-1",
    "aws_content_delivery_url": "https://d1hrvnpk59fvb3.cloudfront.net"
};


export default awsmobile;
